import React from "react";
import useSWR from 'swr';
import { fetchReferenceValues } from './api';

export default function ObservationUnitRange({ id }) {
  const { data } = useSWR(id, fetchReferenceValues);
  return (
    <span>
      {data ? data.range : ''}
    </span>
  );
}
